var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  width: auto;\n  padding: 0;\n"], ["\n  display: block;\n  width: auto;\n  padding: 0;\n"])));
var DropdownList = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    top: 100%;\n    right: 300px\n    width: 300px;\n    z-index: 2;\n    border: 1px solid rgba(0, 0, 0, 0.04);\n    box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14);\n    background-color: white;\n"], ["\n    position: relative;\n    top: 100%;\n    right: 300px\n    width: 300px;\n    z-index: 2;\n    border: 1px solid rgba(0, 0, 0, 0.04);\n    box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14);\n    background-color: white;\n"])));
var DropdownUl = styled.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n"], ["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n"])));
var DropdownLi = styled.li(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 8px 12px;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.14);\n    cursor: pointer;\n  }\n"], ["\n  padding: 8px 12px;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.14);\n    cursor: pointer;\n  }\n"])));
var BurgerMenu = function (props) {
    var container = React.createRef();
    var _a = useState(false), menuVisible = _a[0], setMenuVisible = _a[1];
    var toggleMenuVisibility = function () {
        setMenuVisible(!menuVisible);
    };
    useEffect(function () {
        document.addEventListener('mousedown', handleOutsideClick);
        return function () {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    });
    var handleOutsideClick = function (e) {
        if (container.current && !container.current.contains(e.target)) {
            setMenuVisible(false);
        }
    };
    var handleOptionClick = function (handler) {
        setMenuVisible(false);
        handler();
    };
    return (React.createElement(Container, { ref: container },
        React.createElement(Button, { onClick: toggleMenuVisibility, style: { paddingLeft: 0, minWidth: 0, left: '50%' } }, "\u2630"),
        menuVisible && (React.createElement(DropdownList, null,
            React.createElement(DropdownUl, null,
                React.createElement(React.Fragment, null, props.options.map(function (o) { return (React.createElement(DropdownLi, { key: o.label, onClick: function () { return handleOptionClick(o.handler); } }, o.label)); })))))));
};
export default BurgerMenu;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=BurgerMenu.js.map